
import { Permission, Resource, PermissionType, Role, Company } from "./types";

/**
 * Check if a role has permission for a resource and action within a specific company
 */
export const checkPermission = (
  permissions: Permission[],
  role: Role | undefined,
  resource: Resource,
  permissionType: PermissionType = "read",
  company: Company = "luijten_vvz"
): boolean => {
  if (!role) {
    console.log(`No role provided for permission check on ${resource}`);
    return false;
  }

  console.log(`Checking permission for ${role} - ${resource} - ${permissionType} - company: ${company}`);
  
  // Management role ALWAYS has access to everything
  if (role === "management") {
    console.log(`Management role automatically has ${permissionType} permission for ${resource}`);
    return true;
  }
  
  // Special case for feedback - read/write access for all roles
  if (resource === "feedback" && (permissionType === "read" || permissionType === "write")) {
    console.log(`All roles have ${permissionType} access to feedback`);
    return true;
  }

  // Find permission for the role, resource, and company
  const permission = permissions.find(
    p => p.role === role && p.resource === resource && p.company === company
  );

  if (!permission) {
    console.log(`No permission found for ${role} - ${resource} - ${company}`);
    return false;
  }

  // Check if the role has the requested permission type
  const hasAccess = permission[permissionType] === true;
  console.log(`Permission check result for ${role} - ${resource} - ${permissionType} (${company}): ${hasAccess}`);
  return hasAccess;
};
